export default __webpack_public_path__ + "static/BeslindCuellar-5e84e5ec05d2f66d005e4b9de4b9ff6f.png";